import React, { useState, useEffect } from 'react';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import Loader from "../components/Loader"; 
import { ADMIN_HOME_URL } from '../services/apiConfig';

const Setting = () => {
  const navigate = useNavigate();
  const admin= JSON.parse(localStorage.getItem('admin'));
  const currency= process.env.REACT_APP_CURRENCY;

  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    platform_fee:'',
    vat:'',
    android_version: '',
    ios_version: '',
    payment_mode: '',
    cashback_booking_count: '',
    cashback_percentage: '',
  });

  useEffect(() => {
      getSingleData();
  }, []);
 

const getSingleData = async () => {
    setIsLoader(true);
    try {
        const response = await ApiService.request({
            method: 'GET',
            url: `getSettings`, // Replace with your API endpoint
        });
        const data = response.data;
        if (data.status) {
            setFormData(data.data);
        } else {
            toast.error(data.message);
        }
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoader(false);
    }
};


const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
        
        const response = await ApiService.request({
            method: "POST",
            url: "updateSetting", 
            data: formData
        });
        const data = response.data;
        if (data.status) {
            toast.success(data.message);
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        console.log(error);

        setIsLoader(false);
    }
   
};

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Setting
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href={ADMIN_HOME_URL} className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Setting</li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="card">
                   
                    <div className="card-body pt-0">
                        <div className="mb-8 text-center"></div>
                        <div className="row g-9 mb-8">
                            <div className="col-md-12">
                                    <form className="form" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Platform Fee (AED) </span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="platform_fee"
                                                    value={formData.platform_fee}
                                                    onChange={handleChange}
                                                    required
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Platform Fee"
                                                />
                                            </div>
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">VAT (%) </span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="vat"
                                                    value={formData.vat}
                                                    onChange={handleChange}
                                                    required
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Platform Fee"
                                                />
                                            </div>
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Support Phone </span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="support_phone"
                                                    value={formData.support_phone}
                                                    onChange={handleChange}
                                                    required
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Support Phone"
                                                />
                                            </div>
                                           
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Android Version</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="android_version"
                                                    value={formData.android_version}
                                                    onChange={handleChange}
                                                    required
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Android Version"
                                                />
                                            </div>
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">IOS Version</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="ios_version"
                                                    value={formData.ios_version}
                                                    required
                                                    onChange={handleChange}
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter IOS Version"
                                                />
                                            </div>
                                            
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex required align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="">Payment Mode </span>
                                                </label>
                                                <select name="payment_mode" required className='form-select'
                                                    value={formData.payment_mode}
                                                    onChange={handleChange}>
                                                    <option value="test">Test</option>
                                                    <option value="live">Live</option>
                                                </select>
                                            </div>
                                            
                                            <div className="col-md-6 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Cashback Booking Count</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    name="cashback_booking_count"
                                                    value={formData.cashback_booking_count}
                                                    onChange={handleChange}
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Booking Count for Cashback (e.g., 25)"
                                                />
                                            </div>
                                            
                                            <div className="col-md-6 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Cashback Percentage (%)</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    step={0.01}
                                                    name="cashback_percentage"
                                                    value={formData.cashback_percentage}
                                                    onChange={handleChange}
                                                    className="form-control form-control-solid"
                                                    placeholder="Enter Cashback Percentage (e.g., 2)"
                                                />
                                            </div>
                                            
                                        </div>
                                      
                                        <button
                                        type="submit"
                                        className="btn btn-base my-5"
                                        disabled={isLoader}
                                        >
                                        <span className="indicator-label">
                                            {!isLoader ? "Update Settings" : <Loader size="20" text="Updating" />}
                                        </span>
                                        </button>
                                    </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  );
};

export default Setting;
